import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

import HeaderTabs from '../header-tabs';
import DateSelectionBar from '../date-selection-bar';
import EmptyState from '../empty-state';
import Text,{H1} from '@dbk/ui-text';
import styles from './header.styles';
import DateRangeSelector from '../date-range-selector';

class Header extends PureComponent {
  render() {
    const { maturities, isEmpty, resetSort, messages, dateRangeFn } = this.props;
    return (
      <div className="profile-container">
        <div id="title_maturity_maturityHome_test">
          <H1 className="profile-container__title header margin-top-1" tabIndex={0}>{messages['app.common.pageTitle.maturities']}</H1>
        </div>
        <div testID="maturity-header">
          <div className="edelMaturityHeader">
            <HeaderTabs maturities={maturities} resetSort={resetSort} messages={messages} dateRangeFn={dateRangeFn} />
          </div>
          {isEmpty &&
                    maturities.selectedTab.periodType === 'custom' && (
                      <EmptyState maturities={maturities} messages={messages} />
                    )}
          <div className="row">
            <div id="text_maturities_header_test" className="columns small-6 medium-7 large-9  edelHeaderRow">
              <DateSelectionBar maturities={maturities} messages={messages} />
            </div>
            <span className="columns small-6 medium-5 large-3 ">
              {dateRangeFn.showDateRange && <DateRangeSelector />}
            </span>
          </div>
        </div>
    </div>
    );
  }
}

Header.propTypes = {
  maturities: PropTypes.object.isRequired,
  isEmpty: PropTypes.bool,
  resetSort: PropTypes.func,
  messages: PropTypes.object
};

export default createContainer({
  $fragments: {
    maturities: {
      ...HeaderTabs.getFragment('maturities', 'messages'),
      ...DateSelectionBar.getFragment('maturities', 'messages'),
      ...EmptyState.getFragment('maturities', 'messages'),
      selectedTab: {
        periodType: true,
      },
    },
  },
})(Header);
